import React from 'react'
import PropTypes from 'prop-types'

import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import { formatDocument } from 'utils/masks'

const ViewModal = ({ closeModal, record, translate }) => {
  const renderProducts = (row) => (
    <Row key={row.code}>
      <Col xs={10}>
        <p>{row.name}</p>
      </Col>
      <Col xs={1}>
        <p>{row.productQuantity}</p>
      </Col>
    </Row>
  )

  return (
    <Modal closeModal={closeModal} className='tracking-monitor-viewModal'>
      <p>
        <strong>{translate('totem.trackingMonitor.modal.order')}</strong>
      </p>
      <p>{record.header.orderNumber}</p>
      <p>
        <strong>{translate('totem.trackingMonitor.modal.customerName')}</strong>
      </p>
      <p>{record.header.customer.name}</p>
      <p>
        <strong>
          {translate('totem.trackingMonitor.modal.customerDocument')}
        </strong>
      </p>
      <p>{formatDocument(record.header.customer.document, translate)}</p>

      <Row>
        <Col xs={10}>
          <strong>
            {translate('totem.trackingMonitor.modal.table.products')}
          </strong>
        </Col>
        <Col xs={1}>
          <strong>
            {translate('totem.trackingMonitor.modal.table.quantity')}
          </strong>
        </Col>
      </Row>

      {record.products.map(renderProducts)}

      <Row className='margin-top-quintuple'>
        <Col xs={4} xsOffset={4}>
          <button
            className='button button-primary button-full'
            onClick={closeModal}
          >
            {translate('close_button_label')}
          </button>
        </Col>
      </Row>
    </Modal>
  )
}

ViewModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
}

export default ViewModal
